import { CustomError } from "./custom-error";

export class TooManyCarsError extends CustomError {
  constructor() {
    super('Leider ist derzeit eine Beantragung nicht möglich.')
    
    Object.setPrototypeOf(this, TooManyCarsError.prototype);
  }
}
